import React, { useState, useEffect } from "react"
import { Row, Col, Card, CardBody, CardTitle, Progress } from "reactstrap"
import axios from "axios"
import { DASHCOMPLAINTSTATUS } from "helpers/url_helper"
import { Config } from "helpers/backend_helper"
import ReactApexChart from "react-apexcharts"

const TopComplaintStatus = () => {
    const [colors, setColors] = useState(["#556ee6", "#34c38f", "#f46a6a",  "#ffa500"])
    const [options, setOptions] = useState({})
    const [series, setSeries] = useState([])

    
    useEffect(()=>{
          axios.get(DASHCOMPLAINTSTATUS, Config).then((r)=>{
            if(r.data){
                setOptions({ 
                  labels: r.data.map((d) => d.status), 
                  colors: colors, 
                  legend: { show: !1 },
                  plotOptions: {
                    pie: {
                      donut: {
                        size: "60%",
                      },
                    },
                  },}) 
                  
                setSeries(r.data.map((d) => parseInt(d.count)))
            }
        }).catch((e)=>{
            console.log(e)
        })
        
    },[])
  return (
    <React.Fragment>
    <Col xl="12">
      <Card>
        <CardBody>
          <CardTitle className="mb-4">Customer Complaints Status</CardTitle>
          <div>
              <div id="donut-chart">
                <ReactApexChart
                  options={options}
                  series={series}
                  type="donut"
                  height={358}
                  className="apex-charts"
                />
              </div>
            </div>
            <div className="text-center text-muted">
              <Row>
                <Col xs="4">
                  <div className="mt-4">
                    <p className="mb-2 text-truncate">
                    <i className="mdi mdi-circle me-1" style={{ color: '#556ee6' }} />Completed
                    </p>
                  </div>
                </Col>
                <Col xs="4">
                  <div className="mt-4">
                    <p className="mb-2 text-truncate">
                    <i className="mdi mdi-circle me-1" style={{ color: '#34c38f' }} />Assigned
                    </p>
                  </div>
                </Col>
                <Col xs="4">
                  <div className="mt-4">
                    <p className="mb-2 text-truncate">
                    <i className="mdi mdi-circle me-1" style={{ color: '#f46a6a' }} />Open
                    </p>
                  </div>
                </Col>
              </Row>
            </div>
          
        </CardBody>
      </Card>
      </Col>
    </React.Fragment>
  )
}

export default TopComplaintStatus
